import { FC } from 'react'

import { Box, LinearProgress, Stack, Typography } from '@mui/material'

import { borderRadiusDefault } from '../../../../../themes/theme'
import { toPercent, VisualAttribute } from '../helpers/adDataHelpers'

type VisualAttributeBlockProps = {
  attribute: VisualAttribute
  isColor?: boolean
}

export const VisualAttributeBlock: FC<VisualAttributeBlockProps> = ({ attribute, isColor }) => {
  const percent = toPercent(attribute.value) ?? 0

  return (
    <Stack direction="row" alignItems="center" spacing={1} py={0.25} aria-label={attribute.name}>
      <Stack direction="row" alignItems="center" spacing={1} sx={{ width: '45%', minWidth: 0 }}>
        {isColor && (
          <Box
            title={attribute.name}
            sx={{ width: 14, height: 14, flexShrink: 0, borderRadius: borderRadiusDefault, border: 1, borderColor: 'divider', backgroundColor: attribute.name }}
          />
        )}
        <Typography variant="body2" noWrap title={attribute.name}>
          {attribute.name}
          {attribute.actualValue !== undefined && ` – ${attribute.actualValue}`}
        </Typography>
      </Stack>
      {attribute.value > 0 && (
        <>
          <Typography variant="body2" sx={{ width: 48, flexShrink: 0, textAlign: 'right' }}>
            {percent} %
          </Typography>
          <LinearProgress variant="determinate" value={Math.min(percent, 100)} sx={{ flex: 1, height: 8, borderRadius: borderRadiusDefault }} />
        </>
      )}
    </Stack>
  )
}
